import { JarvisAuthPages as JarvisReactAuthPages } from "@dgs/core";
import { FC, useMemo } from "react";
import { useSearchParams } from "react-router";
import { useFrontendConfig } from "../config/useFrontendConfig";

export const JarvisAuthPages: FC = () => {
	const { authUrl } = useFrontendConfig();
	const [searchParams] = useSearchParams();
	const isFromApp = useMemo(() => {
		return searchParams.get("source") === "eventApp";
	}, [searchParams]);
	const redirect = searchParams.get("redirect") || "/";

	return (
		<JarvisReactAuthPages
			afterSuccessfulLoginPath={isFromApp ? `/app-success` : redirect}
			authUrl={authUrl}
			identityProvidersUrl={`${authUrl}/providers`}
			showPasswordReset={true}
		/>
	);
};
